<template>
  <div class="container">
    <topHeader class="header" title="个人信息协议"></topHeader>
    <div class="title">
      《四川众鹤科技有限公司智慧食堂用户个人信息隐私政策》
    </div>
    <div class="content">
      <p>本隐私政策仅适用于四川众鹤科技有限公司智慧食堂提供的功能或服务。</p>

      <p>版本发布日期：2025年7月15日</p>

      <p>版本生效日期：2025年7月15日</p>

      <p>
        如您有任何疑问、意见或建议，请通过本隐私政策第八部分的联系方式与我公司联系。
      </p>

      <p>
        尊敬的四川众鹤科技有限公司智慧食堂用户（以下简称"您"），四川众鹤科技有限公司（注册地址：成都市天府新区华阳街道祥鹤四街418号1栋10层7号；以下简称"我公司"）始终高度重视并采取措施保护您的个人信息安全。我公司深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我公司致力于维持您对我公司的信任，恪守以下原则，保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则。我公司承诺依法采取相应的安全保护措施来保护您的个人信息，在收集、使用、存储以及共享您的个人敏感信息前，会征得您的明示授权同意。请您在点击或勾选"同意"（具体以界面显示为准）之前仔细阅读本《四川众鹤科技有限公司智慧食堂用户个人信息隐私政策》（以下简称《隐私政策》）（尤其是加粗字体的内容），确保对其内容的含义及相应法律后果已全部知晓并充分理解。如果您不同意本隐私政策的内容以及不及时提供个人信息，我公司将无法为您提供完整的产品和服务，同时您也需要立即停止使用相关的服务。当您点击或勾选"同意"并提交即视为您接受本《隐私政策》，我公司将按照相关法律法规及本《隐私政策》来合法收集、使用、存储、共享和保护您的个人信息。
      </p>

      <p>
        本《隐私政策》将帮助您了解以下内容：
        <br />
        <br />
        1.我公司如何收集和使用您的个人信息
        <br />
        <br />
        2.我公司如何存储您的个人信息
        <br />
        <br />
        3.我公司共享、公开披露、转让您的个人信息的情形及限制
        <br />
        <br />
        4.我公司如何保护您的个人信息
        <br />
        <br />
        5.你如何访问和管理个人信息
        <br />
        <br />
        6.未成年人保护
        <br />
        <br />
        7.第三方提供服务的免责声明
        <br />
        <br />
        8.本《隐私政策》的适用以及更新
        <br />
        <br />
        9.管辖与法律适用
        <br />
        <br />
        10.如何联系我公司
      </p>

      <p>一、我公司如何收集和使用您的个人信息</p>

      <p>（一）我公司如何收集和使用您的个人信息</p>

      <p>
        个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。个人信息包括姓名、出生日期、身份证件号码、通信通讯联系方式、学号、工号等。其中属于个人敏感信息的有：身份证件号码、通信通讯联方式。个人信息一旦被泄露、非法提供或滥用，可能会危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇。
        <strong>我公司将通过用户填写、接口方式获取用户个人信息。</strong>
      </p>

      <p>
        1.当您使用智慧食堂服务时，您可能需要向我公司提供或授权我公司收集相应服务所需的个人信息。如您拒绝提供，您可能将无法使用相应功能或服务。
      </p>

      <p>
        需要特别说明的是，获得敏感权限是我们收集特定信息的必要而非充分条件。我们获得具体某一项敏感权限并不代表我们必然会收集你的相关信息；即使我们已经获得敏感权限，也仅在必要时、根据本指引来收集你的相关信息。
      </p>

      <p>
        2.为向您提供更加准确和便捷的服务，提升服务体验、改进服务质量，或为防范风险，我公司会收集您反馈意见建议或举报时提供的信息，收集您参与问卷调查时向我公司反馈的信息，我公司会对这些信息进行统计、分析，并会根据上述信息向您提供相应服务或产品。
      </p>

      <p>
        3.为向您提供更加准确的服务，提升服务体验、改进服务质量，或为尽可能防范风险，我公司会收集您反馈意见、建议、投诉/举报时提供的信息，收集您使用四川众鹤科技有限公司智慧食堂功能或服务的类别、方式和操作信息，我公司会对这些信息进行综合统计、加工分析，并会根据上述信息向您提供相应的服务或产品。我公司不会强制要求您提供这些信息，您可拒绝提供相应信息。除本政策所约定的其他条款以外，您如拒绝不会对该业务功能的使用和服务体验产生不利影响。
      </p>

      <p>4.其他</p>

      <p>
        我公司在向您提供其他业务功能时，会另行向您说明信息收集的范围与目的，并征得您的同意后方收集提供相应服务所必要的您的信息。我公司会按照本政策以及相应的用户协议约定收集、使用、存储、对外提供及保护您的信息。
      </p>

      <p>（二）我公司收集和使用个人信息的原则</p>

      <p>
        1.我公司收集使用您的个人信息将遵循合法、正当、必要的原则，按照法律法规要求以及业务需要收集您的个人信息，不会收集与业务无关的信息或采取不正当方式收集信息。
      </p>

      <p>
        2.自动采集个人信息的频率应是我公司实现产品或服务的业务功能所必需的最低频率。
      </p>

      <p>
        3.间接获取个人信息的数量应是我公司实现产品或服务的业务功能所必需的最少数量。
      </p>

      <p>
        4.随着我公司业务的发展，可能会对四川众鹤科技有限公司智慧食堂提供的功能或服务进行调整。原则上，当新功能或服务与我公司当前提供的功能或服务相关时，收集与使用的个人信息关联原收集目的。在与原收集目的无关联的场景下，我公司收集、使用您的个人信息，会再次进行告知，并征得您的同意。
      </p>

      <p>（三）我公司收集和使用个人信息的目的</p>

      <p>
        我公司收集您的个人信息，目的在于依法合规的为您提供优质的产品(或服务)，该信息对于充分履行您和我公司之间的合约很有必要，并使得我公司能够遵守相关法律义务，具体可能包括：
        <br />
        <br />
        1.为保护您的账户安全，对您的身份进行识别、验证。
        <br />
        <br />
        2.为评估您的履约能力及履约状况，用于业务准入和防控风险。
        <br />
        <br />
        3.为您提供产品(或服务)所必须。
        <br />
        <br />
        4.为保护您的资金安全。
        <br />
        <br />
        5.为改善产品(或服务)、提升客户体验。
        <br />
        <br />
        6.为履行法定义务(如反洗钱义务)。
        <br />
        <br />
        7.经您许可的其他用途。
      </p>

      <p>
        （四）根据相关法律法规规定、监管要求，以下特殊情形中收集、使用用户的个人信息无需征得您的授权同意：
        <br />
        <br />
        1.与我公司履行法律法规规定的义务相关的；
        <br />
        <br />
        2.与国家安全、国防安全直接相关的；
        <br />
        <br />
        3.与公共安全、公共卫生、重大公共利益直接相关的；
        <br />
        <br />
        4.与刑事侦查、起诉、审判和执行判决或裁定直接相关的；
        <br />
        <br />
        5.出于维护您或其他个人的生命、财产重大合法权益但又很难得到您本人同意的；
        <br />
        <br />
        6.所收集的个人信息是您自行向社会公众公开的；
        <br />
        <br />
        7.从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开渠道；
        <br />
        <br />
        8.根据您要求签订和履行合同所必需的；
        <br />
        <br />
        9.用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；
        <br />
        <br />
        10.为学术研究机构，出于公共利益开展统计或学术研究所必要，且其对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；
        <br />
        <br />
        11.法律法规及监管要求规定的其他情形。
      </p>

      <p>（五）我公司如何使用个人信息</p>

      <p>
        我们在您使用我公司智慧食堂功能或服务过程中收集相关的个人信息是为了向智慧食堂用户打造和提供更好的服务。我们会将收集的信息用于以下用途。
      </p>

      <p>
        1.安全保障：为保障您以及所有智慧食堂用户的安全，我们会利用相关信息协助提升智慧食堂服务的安全性和可靠性，包括检测、防范和应对可能危害智慧食堂、我们的用户或公众的欺诈行为、滥用行为、非法行为、安全风险和技术问题等。
      </p>

      <p>
        2.提供、维护及开发智慧食堂服务：我们会利用收集的信息来提供和优化改进智慧食堂服务，例如根据智慧食堂日志、服务使用信息等为您或您所在企业用户提供各类数据统计分析功能及服务等。
      </p>

      <p>
        3.为了遵从相关法律法规、部门规章、政府指令的相关要求。目前，我们不会将您的个人信息用于个性化推荐或广告用途。如我们使用您的个人信息，超出了与收集时所声称的目的及具有直接或合理关联的范围，我们将在使用您的个人信息前，通过页面提示、交互流程、网站公告等方式另行向您告知并征得您的明示同意。
      </p>

      <p>
        4.对于企业控制的数据的使用，我们将根据企业用户的决定以及我们与企业用户的相关协议依法予以处理。例如，企业用户有权决定在智慧食堂内展示哪些以及如何展示最终用户的相关信息。
      </p>

      <p>
        5.当我公司公开披露您的个人信息时，我公司会采用包括内容替换、匿名化处理方式对您的信息进行脱敏，以保护您的信息安全。
      </p>

      <p>6.根据法律法规或监管要求向相关部门进行报告。</p>

      <p>7.将您的个人信息用于法律允许的其它用途。</p>

      <p>二、我公司如何存储您的个人信息</p>

      <p>
        （一）我公司收集和产生的个人信息，将存储在中华人民共和国境内。我公司将按照法律、行政法规和相关监管部门的规定，采取有效措施保护您的信息安全。
      </p>

      <p>
        （二）我公司仅在法律法规要求的期限（五年）内，以及为实现本《隐私政策》声明的目的所必须的期限内，确定单个用户数据的最长储存期限以及用户日志的储存期限，但经您另行授权同意的除外。当超过数据保存期限后，我公司会对您的信息进行删除或匿名化处理。
      </p>

      <p>三、我公司共享、公开披露、转让您的个人信息的情形及限制</p>

      <p>（一）共享</p>

      <p>
        我公司不会向其他任何公司、组织和个人共享或转让您的个人信息，但以下情况除外：
        <br />
        <br />
        1.事先获得您的明示同意；
        <br />
        <br />
        2.如业务需要对外共享、转让您的个人信息，我公司会向您告知共享个人信息的目的、数据接收方的类型以及可能产生的后果，并事先征得您的授权同意。涉及敏感信息的，我公司还会告知敏感信息的类型、数据接收方的身份和数据安全能力，并征得您的明示同意。
        <br />
        <br />
        3.为实现外部处理的目的，我们可能会与关联公司或其他第三方合作伙伴分享您的个人信息，让他们按照我们的说明、隐私政策以及其他相关的保密和安全措施来为我们处理上述信息，并用于向您提供我们的服务，实现"我们如何使用信息"部分所述目的。如我们与上述关联公司或第三方分享您的信息，我们将会采用加密、匿名化处理等手段保障您的信息安全。
        <br />
        <br />
        4.请您理解，我公司可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。
        <br />
        <br />
        5.我公司会对合作方获取个人信息的应用程序接口（API）、软件工具开发包（SDK）进行严格的安全检测，并与合作方约定严格的数据保护措施，令其按照我公司的委托目的、服务说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。
      </p>

      <p>（二）公开披露</p>

      <p>
        我公司仅会在以下情况下，公开披露您的个人信息：
        <br />
        <br />
        1.事先获得您明确同意或授权。
        <br />
        <br />
        2.根据法律法规规定，或按政府主管部门或司法机关的强制性要求，我公司可能会公开披露您的个人信息，且无需提前通知您或征得您的明示授权同意。
      </p>

      <p>（三）转让</p>

      <p>
        我公司不会将您的个人信息转让给任何其他任何公司、组织和个人，但以下情况除外：
        <br />
        <br />
        1.事先获得您明确同意或授权。
        <br />
        <br />
        2.在涉及合并、收购或破产清算类似交易时，如涉及个人信息转让，我公司会要求新的持有您个人信息的公司、组织继续受此个人信息保护政策的约束，否则我公司将要求该公司、组织重新向您征求授权同意。
      </p>

      <p>（四）征得授权同意的例外</p>

      <p>
        根据相关法律法规、监管规定及国家标准，以下情形中遇到国家有权机关或者监管机关强制性要求的，或者出于对您的权利、权益进行充分保护的目的，或者符合此处约定的其他合理情形的，我公司可能会共享、转让、公开披露个人信息而无需事先征得您授权同意：
        <br />
        <br />
        1.与履行国家法律法规及行业主管部门有关规定的义务相关的；
        <br />
        <br />
        2.与国家安全、国防安全直接相关的；
        <br />
        <br />
        3.与公共安全、公共卫生、重大公共利益直接相关的；
        <br />
        <br />
        4.与刑事侦查、起诉、审判和判决执行直接相关的；
        <br />
        <br />
        5.出于维护您或其他个人的生命、财产、声誉重大合法权益但又很难得到您本人同意的；
        <br />
        <br />
        6.您自行向社会公众公开的个人信息；
        <br />
        <br />
        7.从合法公开披露的信息中收集的个人信息，如合法的新闻报道、政府信息公开渠道。
      </p>

      <p>四、我公司如何保护您的个人信息</p>

      <p>
        （一）为保障您的信息安全，我公司致力于使用各种安全技术及配套的管理体系来尽量降低您的信息被泄露、毁损、误用、非授权访问、非授权披露和更改的风险。我们将在合理的安全水平内使用各种安全保护措施以保障信息的安全。例如，我们会使用加密技术（例如，SSL/TLS）、匿名化处理等手段来保护您的个人信息。同时我公司设立了相关内控制度，对可能接触到您的信息的工作人员采取最小够用授权原则；对工作人员处理您的信息的行为进行系统监控，不断对工作人员培训相关法律法规及隐私安全准则和安全意识强化宣导。
      </p>

      <p>
        （二）我公司会定期组织内部相关人员进行应急响应培训和应急演练，使其掌握岗位职责和应急处置策略和规程。在不幸发生个人信息安全事件后，我公司将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我公司已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施。我公司将及时将事件相关情况以APP推送通知、发送邮件/短消息方式（我公司将根据实际情况选择一种或多种方式）告知您，难以逐一告知个人信息主体时，我公司会采取合理、有效的方式发布公告。同时，我公司还将按照监管部门要求，主动上报个人信息安全事件的处置情况。若您的合法权益受损，我公司将承担相应的法律责任。
      </p>

      <p>
        （三）您知悉并同意，您接入四川众鹤科技有限公司所用的系统和通讯网络，有可能因我公司可控范围外的因素而出现问题。因此，我公司强烈建议您采取积极措施保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的账号密码及相关个人信息透露给他人。一旦您泄漏了前述信息，您可能会蒙受损失，并可能产生对您不利的法律后果。
      </p>

      <p>
        （四）您知悉并同意，尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全，我公司将尽力确保您提供给我公司的个人信息的安全性。
      </p>

      <p>
        （五）在您注销四川众鹤科技有限公司智慧食堂应用后，我公司会停止对您的信息的收集和使用，法律法规或监管部门另有规定的除外。如我公司停止运营，我公司将及时停止收集您个人信息的活动，同时将此前收集的您的相关个人信息进行归档，以便您或监管部门备查。
      </p>

      <p>五、第三方提供服务的免责声明</p>

      <p>
        我公司提供的相关服务中可能包括链接至第三方提供的信息或其他服务(包括网站)。该第三方服务可能由相关的第三方运营。您使用该第三方服务(包括您向该第三方提供的任何个人信息)，须受该第三方的服务条款及隐私政策(而非本《隐私政策》)约束，您需要仔细阅读其条款并自行决定是否接受。我们会尽商业上的合理努力去要求第三方主体对您的个人信息采取保护措施，但我们无法保证这些主体一定会按照我们的要求采取保护措施，请您与他们直接联系以获得关于他们的隐私权政策的详细情况。如您发现这些第三方服务存在风险时，建议您终止相关操作以保护您的合法权益。
      </p>

      <p>
        本《隐私政策》仅适用于我们所收集、保存、使用、共享、披露、转让信息，并不适用于任何第三方提供的服务或第三方的信息使用规则，如果由于任何第三方原因导致您的信息泄露，所有损失均由第三方承担，我公司不承担任何责任。
      </p>

      <p>六、本《隐私政策》的适用以及更新</p>

      <p>
        （一）我公司保留不时更新或修改本《隐私政策》的权利。本《隐私政策》适用于四川众鹤科技有限公司智慧食堂应用所有的用户。未经您明确同意，我公司不会减少您按照本《隐私政策》所应享有的权利。我公司会通过推送通知、弹窗形式、官网公告通知合理方式通知您，以便您能及时了解本《隐私政策》所做的任何变更（包括业务功能变更、使用目的变更、个人信息保护相关负责人联络方式变更情形）。
      </p>

      <p>
        （二）对于重大变更，视具体情况我公司可能还会提供更为显著的通知说明本《隐私政策》具体变更内容。重大变更包括但不限于：
        <br />
        <br />
        1.我公司的服务模式和业务形态发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式。
        <br />
        <br />
        2.个人信息共享、转让或公开披露的主要对象发生变化。
        <br />
        <br />
        3.您参与个人信息处理方面的权利及其行使方式发生重大变化。
        <br />
        <br />
        4.我公司负责处理个人信息安全的联络方式及投诉渠道发生变化。
        <br />
        <br />
        5.个人信息安全影响评估报告表明存在高风险时。
      </p>

      <p>
        （三）若您不同意修改后的隐私政策，您有权并应立即停止使用我公司产品（或服务）。如果您勾选同意修改后的隐私政策并继续使用我公司产品（或服务），则视为您接受我公司对本《隐私政策》相关条款所做的修改。
      </p>

      <p>七、管辖与法律适用</p>

      <p>
        （一）本《隐私政策》的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律。
      </p>

      <p>
        （二）本《隐私政策》签订地为中华人民共和国四川省成都市天府新区。当您因为本隐私政策的实施与我公司产生任何纠纷时，双方应首先协商友好解决；若不能协商解决，双方均有权向四川众鹤科技有限公司所在地有管辖权的人民法院提起诉讼。
      </p>

      <p>
        （三）本《隐私政策》条款无论因何种原因部分无效或不可执行，其余条款仍有效，对您和我公司具有约束力。
      </p>

      <p>八、如何联系我公司</p>

      <p>
        当您有其他的投诉、建议、未成年人个人信息相关问题时，请将您的问题发送至或寄到如下地址：
      </p>

      <p>
        成都市天府新区华阳街道祥鹤四街418号1栋10层7号，廖伟 028-60656777（收）
      </p>

      <p>邮箱：liaowei@zhonghezhihui.com</p>

      <p>邮编：610213</p>
    </div>
    <div
      v-if="isShowBtn && !this.$store.getters.isAgreeUser"
      :class="['btn', { disabled: time > 0 }]"
      @click="confirmPolicy"
    >
      {{ time > 0 ? `我已阅读并同意协议 (${time}s)` : '我已阅读并同意协议' }}
    </div>
    <van-overlay :show="loading"></van-overlay>
  </div>
</template>

<script>
import topHeader from '@/components/topHeader';
import { addAuth } from '@/api/user/index.js';
import { Toast } from 'vant';

export default {
  components: { topHeader },
  data() {
    return {
      isShowBtn: !JSON.parse(
        sessionStorage.getItem('personInfo')
      ).userAuths.some((item) => item.channel === 0 && item.type === 0),
      time: 5,
      loading: false,
      hasScrolled: false, // 标记是否已经滑动过
      timer: null // 存储定时器
    };
  },
  created() {},
  mounted() {
    if (this.isShowBtn && !this.$store.getters.isAgreeUser) {
      this.startCountdown();
    }
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  methods: {
    async confirmPolicy() {
      if (this.time > 0) return;
      try {
        this.loading = true;

        // 分情况,给傻逼擦屁股
        // if (
        //   JSON.parse(sessionStorage.getItem('personInfo')).photo &&
        //   !JSON.parse(sessionStorage.getItem('personInfo')).userAuths.some(
        //     (item) => item.channel === 0 && item.type === 1
        //   )
        // ) {
        //   this.$store.commit('user/SET_IS_AGREE_USER', true);

        //   Toast.success('成功');
        //   this.$router.push({
        //     name: 'Home'
        //   });
        // } else {
        // const res = await addAuth({
        //   organizationId: this.$store.getters.organizationId,
        //   userId: this.$store.getters.userId,
        //   type: 0,
        //   channel: 0
        // });
        // if (res.code === 0) {
        this.$store.commit('user/SET_IS_AGREE_USER', true);
        this.$store.commit('user/SET_IS_SHOW_PROTOCOL', true);

        Toast.success('已勾选《个人信息协议》');
        this.$router.push({
          name: 'Home'
        });
        // }
        // }
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
    startCountdown() {
      this.timer = setInterval(() => {
        if (this.time > 0) {
          this.time--;
        } else {
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background-color: #ffffff !important;
  overflow: auto;
  .title::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background-color: #e5e5e5;
    height: 1px;
    transform: scaleY(0.5);
  }
  .title {
    position: relative;

    padding-top: 28px;
    color: #333333;
    font-size: 18px;
    font-weight: 500;
    font-family: 'PingFang SC';
    text-align: center;
  }
  .content {
    padding: 0 16px 65px 16px;
    margin-top: 24px;
    background-color: #ffffff;

    p {
      background-color: #ffffff;

      color: #666666;
      font-size: 14px;
      font-weight: 400;
      font-family: 'PingFang SC';
      line-height: 21px;
      text-indent: 2em;
      text-align: justify; /* 两端对齐 */
      text-justify: inter-word; /* 单词间调整间距（适合英文） */
      text-justify: inter-character; /* 字符间调整间距（适合中文） */
    }
  }
  .btn {
    width: 375px;
    height: 44px;
    opacity: 1;
    background: #fa5050;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-size: 18px;
    font-weight: 500;
    font-family: 'PingFang SC';
    position: absolute;
    bottom: 21px;
  }
  .disabled {
    background-color: #fdcaca;
  }
  ::v-deep .van-overlay {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.7);
    z-index: 4000;
  }
}
</style>
